// extracted by css-extract-rspack-plugin
export default {"fullWidth":"zHjVlwsML4gkIOzE"};